import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import {withRouterParams} from "../../utils/withRouterParams";

// El tab Perfil se retiró (2026-07-06): "Tipo de negocio" vive en Configuración y el resto del
// perfil (industria/KPI/notas) lo reemplaza la Memoria del Cliente. La ruta queda como redirect
// para links viejos. El form sigue existiendo (ClientProfileForm) para el panel del generador
// de reportes (ClientProfileSidePanel).
export class ClientProfile extends Component {
    render() {
        return <Navigate to={`/client/${this.props.match.params.id}/configuration`} replace/>;
    }
}

export default withRouterParams(ClientProfile);
